

import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import Trust from "@/components/Trust";
import CTAButton from "@/components/CTAButton";
import Footer from "@/components/Footer";
import { Chrome, Sparkles } from "lucide-react";

const Index = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isFirefox = userAgent.includes('firefox');
  const isEdge = userAgent.includes('edg/');
  
  const openStore = () => {
    if (isFirefox) {
      window.location.href = "https://addons.mozilla.org/firefox/downloads/file/4529261/pdf_search_helper-1.0.0.xpi";
      return;
    }
    const url = "https://chromewebstore.google.com/detail/pdf-search-helper/bficdbgmiiecnmoldiffehkhcafobnkl";
    const width = window.screen.width;
    const height = window.screen.height;
    window.open(
      url,
      "ExtensionStore",
      `width=${width},height=${height},left=0,top=0`
    );
  };

  const getBrowserName = () => {
    if (isFirefox) return "Firefox";
    if (isEdge) return "Edge";
    return "Chrome";
  };

  const buttonClassName = "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 transition-all duration-300";

  return (
    <div className="min-h-screen">
      <Hero />
      <Benefits />
      <Trust />
      <div className="py-24 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 text-center relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-1/4 w-32 h-32 bg-blue-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-1/4 w-24 h-24 bg-indigo-400 rounded-full blur-2xl"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4">
          <div className="mb-6">
            <Sparkles className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Start Finding PDFs Faster Today
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto">
            Join thousands of users who use PDF Search Helper to find documents more efficiently
          </p>
          <div className="flex justify-center">
            <CTAButton onClick={openStore} className={buttonClassName + " cta-2 py-6 px-12 text-xl"}>
              <Chrome className="w-6 h-6 mr-3" />
              {`Add to ${getBrowserName()}`}
            </CTAButton>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Index;
